export default [
  {
    path: '/oauth_callback',
    name: 'OauthCallback',
    component: () => import('@/views/wxCode/index.vue'),

  },

]